var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511 511",
    style: {
      enableBackground: "new 0 0 511 511"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.4,331.4h155.8c17.6-51.9,91.3-51.5,108.7,0h13v-74.9c0-9.3-7.6-17-17-17c-38.3,0-76.5,0-114.8,0 c-8.3,0-15-6.7-15-15v-89.9H76.7v18h27.5c19.7,0,19.7,30,0,30H76.7v29h71.9c19.7,0,19.7,30,0,30H76.7v89.9h17 C111.3,279.5,185,280,202.4,331.4z M46.7,182.7h-18c-19.7,0-19.7-30,0-30h18v-32.9c0-8.3,6.7-15,15-15c22.9,0,274.8,0.1,274.8,0 c41,0,76.7,20.3,97.7,55.6l29.4,49.3c25.6,0.3,46.4,21.3,46.4,46.9v89.9c0,8.3-6.7,15-15,15h-26.1c-5.4,26.4-28.7,45.9-56.3,45.9 c-27.5,0-50.9-19.5-56.3-45.9H204.3c-5.4,26.4-28.7,45.9-56.3,45.9s-50.9-19.5-56.3-45.9H61.7c-8.3,0-15-6.7-15-15v-44.9H13.8 c-19.7,0-19.7-29.9,0-29.9h32.9v-30H13.8c-19.7,0-19.7-30,0-30h32.9V182.7z M432.1,330.5c10.7,10.7,10.7,28.1,0,38.8 c-17.2,17.2-46.9,5-46.9-19.4C385.2,325.5,414.8,313.2,432.1,330.5z M428.9,209.6h-65.6v-70.8c19.1,6.1,34.7,19,45.4,36.9 L428.9,209.6z M167.5,330.5c10.7,10.7,10.7,28.1,0,38.8c-17.2,17.2-46.9,5-46.9-19.4C120.6,325.5,150.2,313.2,167.5,330.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.139f911dfb6ca85d84dce2c492429939.svg";
export { ForwardRef as ReactComponent };